import styled from '@emotion/styled'

export const OrganizationWrapper = styled.div`
  display: flex;
  align-items: center;
`
